'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CountdownTimer = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(CountdownTimer, _Component);

  function CountdownTimer(props) {
    (0, _classCallCheck3.default)(this, CountdownTimer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CountdownTimer.__proto__ || (0, _getPrototypeOf2.default)(CountdownTimer)).call(this, props));

    _this.timer = null;

    _this.initial = _this.initial.bind(_this);
    _this.countDown = _this.countDown.bind(_this);
    _this.state = {
      time: 0
    };
    return _this;
  }

  (0, _createClass3.default)(CountdownTimer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.initial();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.timer);
    }
  }, {
    key: 'initial',
    value: function initial() {
      var _props = this.props,
          seconds = _props.seconds,
          stop = _props.stop;

      if (seconds && !stop) {
        this.setState({ time: seconds });
        this.timer = setInterval(this.countDown, 1000);
      }
    }
  }, {
    key: 'countDown',
    value: function countDown() {
      var _props2 = this.props,
          stop = _props2.stop,
          onDone = _props2.onDone;
      var time = this.state.time;

      if (time && !stop) {
        this.setState({ time: time - 1 });
      } else {
        if (onDone) {
          onDone();
        }
        clearInterval(this.timer);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var time = this.state.time;
      var _props3 = this.props,
          className = _props3.className,
          noWrapper = _props3.noWrapper,
          textRight = _props3.textRight,
          textLeft = _props3.textLeft;

      return _react2.default.createElement(
        'div',
        { className: className },
        !noWrapper && '(',
        !!textLeft && textLeft,
        time,
        !!textRight && textRight,
        !noWrapper && ')'
      );
    }
  }]);
  return CountdownTimer;
}(_react.Component), _class.propTypes = {
  seconds: _propTypes2.default.number,
  stop: _propTypes2.default.bool,
  noWrapper: _propTypes2.default.bool,
  onDone: _propTypes2.default.func,
  className: _propTypes2.default.string,
  textLeft: _propTypes2.default.string,
  textRight: _propTypes2.default.string
}, _temp);
exports.default = CountdownTimer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/CountdownTimer.js
// module id = 1515
// module chunks = 0